import linuxLogo from '../assets/linux-logo.png';
import logoCarleton from '../assets/logo-carleton.png';
import logoPathways from '../assets/logo-pathways.png';
import logoSM from '../assets/logo-sm.png';
import profile from '../assets/profile.jpg';
import projClass from '../assets/proj-class.png';
import projChat from '../assets/project-chat.webp';
import projGhost from '../assets/project-ghost.png';
import projMusic from '../assets/project-music.jpg';
import projElevator from '../assets/proj-elevator.png';
import projGeo from '../assets/proj-geo.png';
import projLibrary from '../assets/proj-library.webp';
import projPortfolio from '../assets/proj-portfolio.png';
import projRobot from '../assets/proj-robot.webp';
import windowsLogo from '../assets/windows-logo.png';
import ytIcon from '../assets/yt-icon.png';
import about1 from '../assets/about1.PNG';
import contact from '../assets/contact.png';
import contact2 from '../assets/contact2.png';
import githubIcon from '../assets/github-icon.png';

export const allImages = [
  linuxLogo,
  logoCarleton,
  logoPathways,
  logoSM,
  profile,
  projClass,
  projChat,
  projGhost,
  projMusic,
  projElevator,
  projGeo,
  projLibrary,
  projPortfolio,
  projRobot,
  windowsLogo,
  ytIcon,
  about1,
  contact,
  contact2,
  githubIcon,
];
